export default __webpack_public_path__ + "static/media/pickup-dark.356841bc.svg";